/* PEFSA · dispatch day of the product page delivery panel (snippets/pefsa-delivery.liquid, CHANGELOG-TEMA (61)).
   Informative only: "Se envía mañana · si compras antes de las 3:00 p.m.". It reads nothing from the cart and asks
   Shopify for no shipping rates: costs, carriers and the free-shipping gap live in the cart and the checkout.

   Dispatch promise (decisiones.md [ENT-001]): orders confirmed before the published cutoff (3:00 p.m., Mexico City)
   on a working day leave on the next working day. Working days: Monday to Friday, minus the mandatory rest days of the
   Ley Federal del Trabajo (art. 74) and the extra closed dates in snippets/pefsa-dispatch-config.liquid. Calendar
   math runs on UTC dates so the shopper's own time zone never shifts the result. */
(() => {
  if (customElements.get('pefsa-delivery')) return;

  const DAY_MS = 86400000;
  const WEEKDAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const iso = (date) => date.toISOString().slice(0, 10);

  function mexicoCityNow() {
    const parts = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach((part) => { parts[part.type] = Number(part.value); });
    return { date: new Date(Date.UTC(parts.year, parts.month - 1, parts.day)), minutes: parts.hour * 60 + parts.minute };
  }

  function nthMonday(year, month, n) {
    const first = new Date(Date.UTC(year, month, 1));
    const offset = (8 - first.getUTCDay()) % 7;
    return new Date(Date.UTC(year, month, 1 + offset + (n - 1) * 7));
  }

  function lftHolidays(year) {
    const days = [
      new Date(Date.UTC(year, 0, 1)), nthMonday(year, 1, 1), nthMonday(year, 2, 3), new Date(Date.UTC(year, 4, 1)),
      new Date(Date.UTC(year, 8, 16)), nthMonday(year, 10, 3), new Date(Date.UTC(year, 11, 25))
    ];
    if (year >= 2024 && (year - 2024) % 6 === 0) days.push(new Date(Date.UTC(year, 9, 1)));
    return days.map(iso);
  }

  function dispatchConfig() {
    let raw = {};
    try { raw = JSON.parse(document.querySelector('[data-pefsa-dispatch-config]').textContent); } catch (e) { /* defaults */ }
    return {
      cutoff: (Number(raw.cutoff) || 15) * 60,
      days: String(raw.days || '1,2,3,4,5').split(',').map(Number),
      closed: String(raw.closed || '').split(',').map((s) => s.trim()).filter(Boolean)
    };
  }

  function dispatchPlan() {
    const config = dispatchConfig();
    const now = mexicoCityNow();
    const closed = new Set(config.closed);
    const year = now.date.getUTCFullYear();
    [year, year + 1].forEach((y) => lftHolidays(y).forEach((d) => closed.add(d)));
    const isWorking = (date) => config.days.includes(date.getUTCDay()) && !closed.has(iso(date));
    const nextWorking = (date) => {
      let next = new Date(date.getTime() + DAY_MS);
      for (let i = 0; i < 60 && !isWorking(next); i += 1) next = new Date(next.getTime() + DAY_MS);
      return next;
    };
    const beforeCutoff = isWorking(now.date) && now.minutes < config.cutoff;
    const processDay = beforeCutoff ? now.date : nextWorking(now.date);
    const hour = Math.floor(config.cutoff / 60);
    return {
      beforeCutoff,
      shipDay: nextWorking(processDay),
      today: now.date,
      cutoffLabel: `${hour > 12 ? hour - 12 : hour}:00 ${hour >= 12 ? 'p.m.' : 'a.m.'}`
    };
  }

  function dayLabel(day, today) {
    if (Math.round((day - today) / DAY_MS) === 1) return 'mañana';
    const month = day.getUTCMonth() !== today.getUTCMonth() ? ` de ${MONTHS[day.getUTCMonth()]}` : '';
    return `el ${WEEKDAYS[day.getUTCDay()]} ${day.getUTCDate()}${month}`;
  }

  class PefsaDeliveryElement extends HTMLElement {
    connectedCallback() {
      const head = this.querySelector('[data-dispatch-head]');
      const cond = this.querySelector('[data-dispatch-cond]');
      if (head && cond) {
        // Re-rendered on each minute boundary so the cutoff and the day roll over while the page stays open.
        const tick = () => {
          try {
            const plan = dispatchPlan();
            head.textContent = `Se envía ${dayLabel(plan.shipDay, plan.today)}`;
            cond.textContent = plan.beforeCutoff ? `· si compras antes de las ${plan.cutoffLabel}` : '· si compras hoy';
          } catch (e) { /* keep the static text */ }
          this.timer = setTimeout(tick, 60000 - (Date.now() % 60000) + 50);
        };
        tick();
      }
      this.classList.remove('is-pending'); // painted once, already with the real day
    }

    disconnectedCallback() { clearTimeout(this.timer); }
  }

  customElements.define('pefsa-delivery', PefsaDeliveryElement);
})();
